import React, { useEffect, useState } from 'react';
import { supabase } from '../supabase';

export default function Leaderboard({ onPlay }) {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchLeaderboard();
  }, []);

  async function fetchLeaderboard() {
    setLoading(true);
    setError(null);
    try {
      const { data, error } = await supabase
        .from('leaderboard')
        .select('*')
        .order('score', { ascending: false })
        .limit(10);

      if (error) throw error;
      setEntries(data || []);
    } catch (err) {
      setError('Could not load leaderboard.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  const rankLabel = (i) => {
    if (i === 0) return '🥇';
    if (i === 1) return '🥈';
    if (i === 2) return '🥉';
    return `#${i + 1}`;
  };

  return (
    <div className="lb-wrap fade-in">
      <div style={{ textAlign: 'center', marginBottom: 24 }}>
        <span className="title" style={{ fontSize: 48, color: 'var(--gold)', display: 'block' }}>LEADERBOARD</span>
        <p style={{ color: 'var(--muted)', fontSize: 12, letterSpacing: 3, fontFamily: "'Rajdhani', sans-serif" }}>TOP HEROES — GLOBAL</p>
      </div>

      <div className="card" style={{ padding: '8px 0', minHeight: 120 }}>
        {loading && (
          <p style={{ textAlign: 'center', color: 'var(--muted)', padding: '32px', fontFamily: "'Rajdhani', sans-serif", letterSpacing: 2 }}>
            LOADING...
          </p>
        )}
        {error && (
          <p style={{ textAlign: 'center', color: 'var(--red)', padding: '32px', fontFamily: "'Rajdhani', sans-serif" }}>
            {error}
          </p>
        )}
        {!loading && !error && entries.length === 0 && (
          <p style={{ textAlign: 'center', color: 'var(--muted)', padding: '32px', fontFamily: "'Rajdhani', sans-serif", letterSpacing: 2 }}>
            NO SCORES YET — BE THE FIRST HERO
          </p>
        )}
        {!loading && entries.map((entry, i) => (
          <div className="lb-row" key={entry.id || i}>
            <span className="lb-rank">{rankLabel(i)}</span>
            <div style={{ flex: 1 }}>
              <div className="lb-name">{entry.name}</div>
              <div className="lb-diff">{entry.difficulty} · {new Date(entry.created_at).toLocaleDateString()}</div>
            </div>
            <span className="lb-score">{entry.score.toLocaleString()}</span>
          </div>
        ))}
      </div>

      <div style={{ marginTop: 20 }}>
        <button className="btn btn-primary" onClick={onPlay} style={{ width: '100%', fontSize: 18 }}>
          ⚡ PLAY
        </button>
      </div>
    </div>
  );
}
